<template>
  <!-- 全局提示框-zb -->
  <div class="popup_fiexd message_index">
    <section :class="{red: messagesValue.type == '2' , ccc: messagesValue.type == '3' }">
      {{messagesValue.value}}
    </section>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  data() {
    return {};
  },

  props: {
    messageData: {}
  },

  components: {},

  computed: {
    ...mapState({
      messagesValue: state => state.Sign.messagesValue
    })
  },

  created() {},

  updated() {},

  mounted() {
    let _this = this;
    setTimeout(() => {
      _this.$store.commit("SET_SHOW_FALSE");
    }, _this.messagesValue.time);
  },

  destroyed() {},

  methods: {}
};
</script>

<style lang='less' scoped>
.popup_fiexd {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(150, 150, 150, 0.2);
  z-index: 1000;
  animation: animation1 0.3s ease-out;
}

/* 弹窗取消隐藏滚动条 */
.body_hidden {
  overflow: hidden;
  padding-right: 17px;
}

/* 弹窗动画 */
@keyframes animation1 {
  0% {
    opacity: 0;
  }

  100% {
    opacity: 1;
  }
}
.message_index {
  z-index: 2000;
  section {
    padding: 20px 10px;
    background: #fff;
    text-align: center;
    position: absolute;
    margin: auto;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    min-width: 140px;
    color: #409eff;
    &.red {
      color: red;
    }
    &.ccc {
      color: #666;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/message-box.vue